document.addEventListener('click',event=>{const swatch=event.target.closest('[data-card-swatch]');if(!swatch)return;const card=swatch.closest('[data-b-card]');card.querySelectorAll('[data-card-swatch]').forEach(button=>{const active=button===swatch;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));});if(swatch.dataset.image){const image=card.querySelector('.b-card-image img');if(image){image.removeAttribute('srcset');image.src=swatch.dataset.image;image.alt=swatch.dataset.alt;}}card.querySelectorAll('[data-card-link]').forEach(link=>{if(swatch.dataset.url)link.href=swatch.dataset.url;});});
document.addEventListener('click',async event=>{const button=event.target.closest('[data-cookie-preferences]');if(!button)return;const status=button.parentElement.querySelector('.b-cookie-status');try{const banner=window.privacyBanner||window.Shopify?.privacyBanner;if(!banner?.showPreferences)throw new Error('not-ready');await banner.showPreferences();if(status)status.hidden=true;}catch{if(status){status.textContent='Çerez tercihleri şu anda yüklenemedi. Sayfayı yenileyip tekrar deneyebilirsiniz.';status.hidden=false;}}});

// Store the accepted policy version with the cart. Checkout validation is a
// separate platform concern: this handler covers the theme's checkout forms.
document.addEventListener('submit', async event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !['cart', 'CartDrawer-Form'].includes(form.id)) return;
  const submitter = event.submitter;
  if (submitter?.name !== 'checkout' || form.dataset.bihadaConsentSaved === 'true') return;
  const checkbox = [...document.querySelectorAll('[data-bihada-consent-checkbox]')].find(input => input.form === form);
  if (!checkbox) return;
  event.preventDefault();
  const area = checkbox.closest('[data-bihada-consent]');
  const status = area.querySelector('[data-bihada-consent-status]');
  if (!checkbox.checked) { checkbox.reportValidity(); return; }
  if (form.dataset.bihadaSaving === 'true') return;
  form.dataset.bihadaSaving = 'true';
  submitter.disabled = true;
  status.hidden = true;
  try {
    const version = area.dataset.policyVersion;
    const acceptedAt = new Date().toISOString();
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        'Ön bilgilendirme ve sözleşme onayı': version,
        'Sözleşme onay zamanı (UTC)': acceptedAt,
        'Sözleşme metni': `/pages/mesafeli-satis-sozlesmesi — ${version}`,
        'Ön bilgilendirme metni': `/pages/on-bilgilendirme-formu — ${version}`
      } })
    });
    if (!response.ok) throw new Error('Cart save failed');
    const cart = await response.json();
    if (cart.attributes?.['Sözleşme onay zamanı (UTC)'] !== acceptedAt) throw new Error('Cart confirmation missing');
    if (!checkbox.checked) return;
    form.dataset.bihadaConsentSaved = 'true';
    submitter.disabled = false;
    form.requestSubmit(submitter);
  } catch {
    status.textContent = 'Onayınız kaydedilemedi. Lütfen tekrar deneyin.';
    status.hidden = false;
  } finally {
    delete form.dataset.bihadaSaving;
    submitter.disabled = false;
  }
});
